export const PAGE_SIZE = 20;
export const MODULE_PAGE_SIZE = 8;
export const PIE_CHART_ANWERS = 2;
export const PAGE_TYPE_RESOURCE = "page";
export const POLL_TYPE_RESOURCE = "poll";
export const RESULT_TYPE_RESOURCE = "results";
export const CANVAS_TYPE_RESOURCE = "canvas";
